import { Box, Text } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

export const UpsellAlert = () => {
  return (
    <Box
      gap="s12"
      paddingX="s16"
      paddingY="s8"
      borderRadius={{
        all: 'abs016',
      }}
      flexDirection="row"
      alignItems="center"
      background="champagne200"
    >
      <Box flexDirection="column" flexGrow>
        <Text.Normal size="200" weight="medium" color="black">
          {i18n.t('meetings.one_on_ones.upsell.calendar.title')}
        </Text.Normal>
        <Text.Normal size="200">
          {i18n.t('meetings.one_on_ones.upsell.calendar.description')}
        </Text.Normal>
      </Box>
      <Box flexNoShrink>
        <UpsellingKit.UpsellButton
          label={i18n.t('meetings.one_on_ones.upsell.calendar.button')}
          requestSource="create-one-on-one-modal"
          pageSource="create-one-on-one-modal"
          requestReason={ValidReasons.MissingFeature}
          moduleRequested={AvailableModules.engagement}
          featureRequested={Features.engagement_one_on_one_meetings}
          showModuleModal
        />
      </Box>
    </Box>
  )
}
